import { Component, Input, QueryList, ViewChildren } from '@angular/core';

import { StopsFacade } from '@ridango/components';
import { SelectableCheckableItemComponent } from '@ridango/components/lib/core-ui/basic';
import { ProductCategory } from '@ridango/core';

@Component({
    selector: 'rwidget-group-selector',
    templateUrl: './group-selector.component.html',
})
export class GroupSelectorComponent {
    @Input() groups: ProductCategory[];
    @Input() groupSelected: ProductCategory;
    @Input() step;
    @ViewChildren(SelectableCheckableItemComponent) focusItems: QueryList<any>;

    constructor(private stopsFacade: StopsFacade) {}

    selectGroup(group: ProductCategory) {
        this.stopsFacade.setSelectedGroup(group);
    }

    selectLeft(p: ProductCategory) {
        this.setFocusToSibling(p, -1);
    }

    selectRight(p: ProductCategory) {
        this.setFocusToSibling(p, 1);
    }

    setFocusToSibling(p: ProductCategory, direction: number) {
        let destElId;
        this.groups.some((fp, i) => {
            if (fp.id === p.id) {
                destElId = i + direction;
                return true;
            }
        });
        if (destElId < 0) {
            destElId = this.focusItems.length - 1;
        } else if (destElId >= this.focusItems.length) {
            destElId = 0;
        }
        this.selectGroup(this.groups[destElId]);
        setTimeout(() => this.focusItems.toArray()[destElId].selectCheckItem.nativeElement.focus());
    }

    focus(p: ProductCategory) {
        this.focusItems.toArray()[this.findElementIndex(p)].selectCheckItem.nativeElement.classList.add('focus');
        if (this.groupSelected) {
            // If some item already selected, focusing on item selects
            this.selectGroup(p);
        }
    }

    blur(p: ProductCategory) {
        this.focusItems.toArray()[this.findElementIndex(p)].selectCheckItem.nativeElement.classList.remove('focus');
    }

    findElementIndex(p: ProductCategory) {
        return this.groups.findIndex((fp: ProductCategory) => fp.id === p.id);
    }

    getTabIndex(p: ProductCategory) {
        if (this.groupSelected) {
            if (this.groupSelected.id === p.id) {
                // Selected item
                return 0;
            }
        } else if (this.groups[0].id === p.id) {
            // First item
            return 0;
        }
        return -1;
    }
}
